import { render, staticRenderFns } from "./UnasignDeliveryModal.vue?vue&type=template&id=378e27dd&scoped=true&"
import script from "./UnasignDeliveryModal.vue?vue&type=script&lang=js&"
export * from "./UnasignDeliveryModal.vue?vue&type=script&lang=js&"
import style0 from "./UnasignDeliveryModal.vue?vue&type=style&index=0&id=378e27dd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378e27dd",
  null
  
)

export default component.exports